import { createSelector } from 'reselect';
import {
  giftsForBonusesSumSelector,
  unusedBonusesSum,
  maxBonusesMinusGiftsSelector,
  maxCashbackCanUseSelector,
} from '../pricing/selectors';

export {
  giftsForBonusesSumSelector,
  unusedBonusesSum,
  maxBonusesMinusGiftsSelector,
  maxCashbackCanUseSelector,
};

// текущий уровень лояльности
export const currentLoyaltySelector = createSelector(
  [
    state => state.user.profile.loyalty?.statuses || [],
    state => state.user.profile.loyalty?.status || '',
  ],
  (statuses, status) => statuses.find(({ code }) => code === status),
);
